import { Container, SectionHeading } from '@tt/design-system';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <Container size="narrow" className="flex min-h-[60vh] flex-col items-center justify-center py-16 text-center">
      <SectionHeading
        kicker="Página não encontrada"
        title="Esta página não pertence à taça."
        subtitle="O endereço que você abriu não existe ou foi removido. Volte ao começo."
        align="center"
      />
      <Link
        to="/"
        className="mt-10 inline-flex items-center justify-center rounded-md border border-gold/60 px-6 py-3 font-display text-base text-gold transition-colors duration-base hover:bg-gold/10"
      >
        Voltar ao início
      </Link>
    </Container>
  );
}
